module.exports = __webpack_public_path__ + "static/media/Mama Rochel - Authorization to Apply Topical Preparations.a1495611.pdf";